import { get, post } from '@/utils/request';

/** 获取预警指标列表 */
export function getWarnIndexList(data) {
  return get('/system/warn/getItemCriteriaList', data);
}

/** 设置指标标准值 */
export function setIndexConfig(data) {
  return post('/system/warn/setItemCriteria', data);
}

/** 获取预警指标统计列表 */
export function getWarnIndexStatisticsList(data) {
  return post('/system/warn/getAllWarn', data);
}

/** 获取y预警指标明细列表 */
export function getIndexDetailList(data) {
  return post('/system/warn/getSignD', data);
}

/** 获取高危预警患者统计列表 */
export function getPatientStatistics(data) {
  return post('/system/warn/getHighW', data);
}